// extracted by mini-css-extract-plugin
module.exports = {"logo":"EmailLogin_logo__2Nqd-","row":"EmailLogin_row__BV7KT","btn":"EmailLogin_btn__2Okwx","serverError":"EmailLogin_serverError__3SP1j"};